/*
 * Lagerplaner: reine Rechenfunktionen (ohne DOM). Wird von assets/freezer-page.js (Seite) und vom
 * Prüfskript scripts/devshop/freezer-pruefen.mjs (Node) benutzt, damit die geprüfte Rechnung exakt die
 * ausgelieferte ist. Keine festen Zahlen: alles kommt aus dem Lagersystem-Datensatz (Metaobjekt
 * "lagersystem" mit Bauteilen), der Probenart und den Reglern.
 *
 * Eingabe "sys": { art: 'rack'|'kanister', positionen: [ { anzahl, ebenen_nutzbar, plaetze_je_box, boxtyp,
 *                  goblets_je_kanister, straws_025_je_goblet, straws_05_je_goblet, breite_mm, ... } ] }
 * Probenart "type": 'v' (Vials 1,2/2 ml) | 's25' (Straws 0,25 ml) | 's50' (Straws 0,5 ml)
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.CryoPlanner = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var TYPES = { v: { step: 100 }, s25: { step: 500 }, s50: { step: 250 } };

  function num(x) { x = Number(x); return isFinite(x) ? x : 0; }

  /* Zellen: Rack-Systeme = je Rack und Ebene eine Kryobox (große Boxen zuerst), Kanister-Systeme = je Goblet ein Platz. */
  function cells(sys, type) {
    if (!sys || !sys.positionen || !sys.positionen.length) return null;
    var out = [], g, p, i, l, n, per, list;
    if (sys.art === 'rack') {
      if (type !== 'v') return null;
      list = sys.positionen.slice().sort(function (a, b) { return num(b.plaetze_je_box) - num(a.plaetze_je_box); });
      for (g = 0; g < list.length; g++) {
        p = list[g];
        if (!num(p.plaetze_je_box) || !num(p.ebenen_nutzbar)) return null;
        for (i = 0; i < num(p.anzahl); i++) for (l = 0; l < num(p.ebenen_nutzbar); l++) out.push({ cap: num(p.plaetze_je_box), g: g, r: out.length ? null : 0, rack: i, level: l, box: p.boxtyp });
      }
      /* laufende Racknummer über alle Gruppen */
      var rn = -1, last = '';
      for (i = 0; i < out.length; i++) { var key = out[i].g + ':' + out[i].rack; if (key !== last) { rn++; last = key; } out[i].r = rn; }
      return { kind: 'rack', cells: out, groups: list };
    }
    if (sys.art === 'kanister') {
      if (type !== 's25' && type !== 's50') return null;
      list = sys.positionen.slice();
      for (g = 0; g < list.length; g++) {
        p = list[g];
        per = num(type === 's25' ? p.straws_025_je_goblet : p.straws_05_je_goblet);
        if (!per || !num(p.goblets_je_kanister)) return null;
        n = num(p.anzahl) * num(p.goblets_je_kanister);
        for (i = 0; i < n; i++) out.push({ cap: per, g: g, can: Math.floor(i / num(p.goblets_je_kanister)) });
      }
      return { kind: 'can', cells: out, groups: list };
    }
    return null;
  }

  function capacity(sys, type) {
    var c = cells(sys, type);
    if (!c) return null;
    var s = 0;
    for (var i = 0; i < c.cells.length; i++) s += c.cells[i].cap;
    return s;
  }

  /* Wie viele Zellen werden für "amount" Proben belegt (von vorn gefüllt)? */
  function used(list, amount) {
    var k = 0, a = 0, byGroup = {};
    for (var i = 0; i < list.length; i++) {
      if (a >= amount) break;
      a += list[i].cap; k++;
      byGroup[list[i].g] = (byGroup[list[i].g] || 0) + 1;
    }
    return { k: k, byGroup: byGroup };
  }

  /* Nach wie vielen Jahren ist der Freezer voll? 0 = schon voll, Infinity = nie (kein Zuwachs). */
  function yearsFull(cap, now, grow) {
    if (!(cap > 0)) return null;
    if (now >= cap) return 0;
    if (grow <= 0) return Infinity;
    return (cap - now) / grow;
  }

  /* Gesamtrechnung für einen Planerstand. evap = Verdampfung in l/Tag je Freezer (Nennwert). */
  function plan(sys, type, now, grow, year, evap) {
    var c = cells(sys, type);
    if (!c) return null;
    var cap = 0, i;
    for (i = 0; i < c.cells.length; i++) cap += c.cells[i].cap;
    var stock = now + grow * year;
    var kNow = Math.max(1, Math.ceil(now / cap));
    var kY = Math.max(1, Math.ceil(stock / cap));
    var uNow = used(c.cells, Math.min(now, cap)), uY = used(c.cells, Math.min(stock, cap));
    var res = {
      kind: c.kind, cap: cap, stock: stock, cells: c.cells.length, groups: c.groups,
      yFull: yearsFull(cap, now, grow),
      pct: Math.min(999, Math.round(stock / cap * 100)), pctNow: Math.round(now / cap * 100),
      freezers: kY, freezersNow: kNow, usedNow: uNow.k, usedYear: uY.k,
      over: Math.max(0, stock - cap),
      ln2PerYear: kY * num(evap) * 365
    };
    if (c.kind === 'rack') {
      var full = Math.floor(stock / cap), rem = used(c.cells, stock - full * cap), boxes = {};
      c.groups.forEach(function (g, gi) {
        boxes[g.boxtyp] = full * num(g.anzahl) * num(g.ebenen_nutzbar) + (rem.byGroup[gi] || 0);
      });
      res.boxes = boxes;
      res.boxGroups = c.groups.map(function (g) { return g.boxtyp; });
    } else {
      var perG = c.cells[0].cap;
      res.goblets = Math.ceil(stock / perG);
      var placesPerCan = num(c.groups[0].goblets_je_kanister) || 1, cans = 0;
      c.groups.forEach(function (g) { cans += num(g.anzahl); });
      res.canisters = Math.ceil(Math.min(uY.k, c.cells.length) / placesPerCan);
      res.canistersTotal = cans;
    }
    return res;
  }

  /* Rundung für die Anzeige: eine Nachkommastelle. */
  function round1(x) { return Math.round(x * 10) / 10; }

  return { TYPES: TYPES, cells: cells, capacity: capacity, used: used, yearsFull: yearsFull, plan: plan, round1: round1 };
});
